import React, { useState, useEffect, useRef } from 'react';
import '../styles/Topbar.css';
import logoImg from '../assets/images/logo.png';

const SECTIONS = ['home', 'about', 'experience', 'projects', 'Education', 'contacts'];

const Topbar = () => {
  const [activeSection, setActiveSection] = useState('home');
  const [pillStyle, setPillStyle] = useState({ width: 0, left: 0, opacity: 0 });
  const linkRefs = useRef({});
  const linksRef = useRef(null);

  const navItems = [
    { label: 'About Me',   href: '#about',      id: 'about'      },
    { label: 'Experience', href: '#experience',  id: 'experience' },
    { label: 'Projects',   href: '#projects',    id: 'projects'   },
    { label: 'Education',  href: '#Education',   id: 'Education'  },
    { label: 'Contact',    href: '#contacts',    id: 'contacts'   },
  ];

  // Move pill to the active link
  useEffect(() => {
    const activeEl = linkRefs.current[activeSection];
    const containerEl = linksRef.current;
    if (!activeEl || !containerEl) return;

    const itemRect = activeEl.getBoundingClientRect();
    const containerRect = containerEl.getBoundingClientRect();

    setPillStyle({
      width:   itemRect.width  + 20,
      left:    itemRect.left - containerRect.left - 10,
      opacity: 1,
    });
  }, [activeSection]);

  // Intersection observer for section tracking
  useEffect(() => {
    const observers = [];
    SECTIONS.forEach((id) => {
      const el = document.getElementById(id);
      if (!el) return;
      const observer = new IntersectionObserver(
        ([entry]) => { if (entry.isIntersecting) setActiveSection(id); },
        { threshold: 0.3 }
      );
      observer.observe(el);
      observers.push(observer);
    });
    return () => observers.forEach((o) => o.disconnect());
  }, []);

  return (
    <nav className="topbar">
      <ul className="logo">
        <li>
          <a href="#home" className="logo-link">
            <span className="logo-emblem">
              <img src={logoImg} alt="logo" className="logo-icon" />
            </span>
            Anaiysaa
          </a>
        </li>
      </ul>

      <ul className="links" ref={linksRef}>
        {/* sliding pill */}
        <div
          className="nav-pill"
          style={{
            width:   pillStyle.width,
            transform: `translateX(${pillStyle.left}px) translateY(-50%)`,
            opacity: pillStyle.opacity,
          }}
        />

        {navItems.map(({ label, href, id }) => (
          <li key={id}>
            <a
              href={href}
              ref={(el) => { linkRefs.current[id] = el; }}
              className={activeSection === id ? 'active' : ''}
            >
              {label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Topbar;
